export default __webpack_public_path__ + "static/media/E-KYC-2.d45562dc.png";